import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import GroupArrowIcon from "../../../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/GroupArrowIcon";
import {
  mandatedClassesActionHandler,
  mandateProgramActionHandler,
} from "../../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../../utils/errorTypes";
import CardContainer from "../CardContainer/CardContainer";
import classes from "./MandateNewClassOrSeries.module.scss";

const MandateNewClassOrSeries = ({
  selectedSearchData,
  setSelectedSearchData,
  getUserGroupMandateShotClasses,
  selectVal,
  radioBtnVal,
  repititiveValArr,
  setValue,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedRepetitveVal, setSelectedRepetitveVal] = useState("");
  const [selectedRadioBtnVal, setSelectedRadioBtnVal] = useState(
    radioBtnVal[0]
  );
  const [mandateClassLoader, setMandateClassLoader] = useState(false);

  useEffect(() => {
    // if (selectedSearchData) {
    setValue("mandateNewClassPriority", radioBtnVal[0]);
    // setValue("mandateNewClassRepetitive", repititiveValArr[0].val);
    // }
  }, []);

  const onRadioChange = (e) => {
    const val = e?.target?.value;
    setSelectedRadioBtnVal(val);
  };

  const onSelectChange = (val) => {
    // debugger
    if (selectVal === "Classes")
      setSelectedSearchData({
        ...selectedSearchData,
        selectedDropdownVal: val,
      });
    else
      setSelectedSearchData({
        ...selectedSearchData,
        Programs: {
          ...selectedSearchData?.Programs,
          selectedDropdownVal: val,
        },
      });
    switch (val) {
      case "Monthly":
        setSelectedRepetitveVal("1");
        break;
      case "Quarterly":
        setSelectedRepetitveVal("2");
        break;
      case "Yearly":
        setSelectedRepetitveVal("3");
        break;
      default:
        setSelectedRepetitveVal("");
        break;
    }
  };

  const mandateClass = (classid, usergroupid, Isrepetitive, Frequency) => {
    setMandateClassLoader(true);
    dispatch(
      mandatedClassesActionHandler(
        classid,
        usergroupid,
        Isrepetitive,
        Frequency
      )
    ).then((response) => {
      if (response?.status === 200 && response?.data) {
        setMandateClassLoader(false);
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,

            `Shotclasses "${
              selectedSearchData?.Name?.length > 30
                ? selectedSearchData?.Name?.slice(0, 30) + "..."
                : selectedSearchData?.Name
            }" is linked to user group successfully`
          )
        );
        setSelectedSearchData(null);
        getUserGroupMandateShotClasses("ShotClass");
        setValue("Search", "");
      }
    });
  };

  const mandateProgram = (programid, usergroupid, Isrepetitive, Frequency) => {
    setMandateClassLoader(true);
    dispatch(
      mandateProgramActionHandler(
        programid,
        usergroupid,
        Isrepetitive,
        Frequency
      )
    ).then((response) => {
      if (response?.status === 200 && response?.data) {
        setMandateClassLoader(false);
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Series "${
              selectedSearchData?.Programs?.Name?.length > 30
                ? selectedSearchData?.Programs?.Name?.slice(0, 30) + "..."
                : selectedSearchData?.Programs?.Name
            }" is linked to user group successfully`
          )
        );
        setSelectedSearchData(null);
        getUserGroupMandateShotClasses("Program");
        setValue("Search", "");
      }
    });
  };

  const onSaveClick = () => {
    if (selectVal === "Classes") {
      if (
        (selectedRepetitveVal && selectedRadioBtnVal === radioBtnVal[1]) ||
        selectedRadioBtnVal === radioBtnVal[0]
      )
        mandateClass(
          selectedSearchData?.ID,
          params?.userGroupId,
          selectedRadioBtnVal === "Repetitive" ? 1 : 0,
          selectedRadioBtnVal === "Repetitive" ? selectedRepetitveVal : 0
        );
      else
        dispatch(setErrorHandler(errorTypes?.WARN, "Please Select Frequency"));
    } else if (
      (selectedRepetitveVal && selectedRadioBtnVal === radioBtnVal[1]) ||
      selectedRadioBtnVal === radioBtnVal[0]
    )
      mandateProgram(
        selectedSearchData?.Programs?.ID,
        params?.userGroupId,
        selectedRadioBtnVal === "Repetitive" ? 1 : 0,
        selectedRadioBtnVal === "Repetitive" ? selectedRepetitveVal : 0
      );
    else dispatch(setErrorHandler(errorTypes?.WARN, "Please Select Frequency"));
  };
  return (
    selectedSearchData && (
      <div className={classes.mandateNewClass}>
        <div className={classes.mandateNewClassHeading}>
          <GroupArrowIcon />
          <div className={classes.text}>
            {selectVal === "Classes"
              ? "Mandate New Shotclasses"
              : "Mandate New Series"}
          </div>
        </div>

        <CardContainer
          data={
            selectVal === "Classes"
              ? selectedSearchData
              : selectedSearchData?.Programs
          }
          repititiveValArr={repititiveValArr}
          onSelectChange={onSelectChange}
          radioBtnVal={radioBtnVal}
          onRadioChange={onRadioChange}
          onSaveClick={onSaveClick}
          key={selectedSearchData?.ID}
          dropDownName={`mandateNewClassRepetitive`}
          radioBtnFieldName={`mandateNewClassPriority`}
          radioBtnName={`mandateNewClassPriority`}
          isDelete={false}
          selectedRadioBtnVal={selectedRadioBtnVal}
          buttonLoader={mandateClassLoader}
          selectVal={selectVal}
          selectedRepetitveVal={selectedRepetitveVal}
        />
      </div>
    )
  );
};

export default MandateNewClassOrSeries;
